import { BareButton } from '@calendly/ui/components/bare-button';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
import CheckIcon from './check.svg';
const stepTitleCss = "s1x4a4ma";
const StepTitle = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(stepTitleCss, props.className)} />);
const stepControlsCss = "sdmcgrk";
export const StepControls = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepControlsCss, props.className)} />;
});
const stepContainerSelectedCss = "s1r6bfdx";
const stepContainerCss = "s8z1ats";
const StepContainer = forwardRef((props, ref) => {
  const {
    selected
  } = props;
  return <Sheet ref={ref} {...props} className={classNames(stepContainerCss, {
    [stepContainerSelectedCss]: selected
  }, props.className)} />;
});
const stepDisabledMessageCss = "sr5gfy9";
const StepDisabledMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepDisabledMessageCss, props.className)} />;
});
export const Step = ({
  selected,
  title,
  complete,
  disabled,
  onSelect,
  children,
  disabledMessage
}) => <StepContainer selected={selected}>
    <StepTitle disabled={disabled} onClick={onSelect} aria-label={title}>
      {title}
      {complete && <img alt="" src={CheckIcon} />}
      {disabledMessage && disabled && <StepDisabledMessage>
          {disabledMessage}
        </StepDisabledMessage>}
    </StepTitle>
    {selected && children}
  </StepContainer>;

require("./step.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./step.js");